<!-- 註解CDK動作 -->
<!-- <div 
  class="side-chatbot-btn" 
  [ngClass]="currentRouteClass"
  cdkDrag
  cdkDragBoundary="body"
> -->
<div 
  class="side-chatbot-btn" 
  [ngClass]="currentRouteClass"
>
  @if (isExpanded && showStatus !== CHATBOT_SHOW_STATUS.HIDE) {
    <div class="chat-msg-group">
      <div class="chat-msg-header">
        <button mat-button class="btn-icon" (click)="closeChat()">
          <img width="24" height="24" src="assets/img/i-close.svg" alt="" />
        </button>
      </div>
      <div class="chat-msg-body">
        @for (chatRecord of chatRecords; track $index) {
          <div [class.left]="chatRecord.isBot" [class.right]="!chatRecord.isBot">
            @if (chatRecord.isBot) {
              <div class="avatar">
                <img width="20" height="20" src="assets/img/img-ai-bot.svg" alt="" />
              </div>
            }
            <div class="msg-content">
              <div class="msg-text" [innerHTML]="chatRecord.text"></div>
              <div class="msg-time">{{ chatRecord.timestamp || getCurrentTime() }}</div>
            </div>
          </div>
        }
        
        @if (isLoading) {
          <div class="left">
            <div class="avatar">
              <img width="20" height="20" src="assets/img/img-ai-bot.svg" alt="" />
            </div>
            <div class="msg-content loading-msg">
              <div class="typing-indicator">
                <span></span><span></span><span></span>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
<!-- 註解CDK動作 -->
  <!-- <div cdkDragHandle style="cursor: move;"> -->
  <div >
    @if (showStatus === CHATBOT_SHOW_STATUS.COLLAPSED) {
      <button mat-button class="btn-icon btn-ai-chat btn-ai-chat-collapsed" (click)="expandChat()">
        <img src="assets/img/img-sidebar-chatbot.svg" alt="" />
      </button>
    } @else if (showStatus === CHATBOT_SHOW_STATUS.EXPANDED) {
      <div class="input-chat-group">
        @if (!isExpanded && showStatus !== CHATBOT_SHOW_STATUS.HIDE) {
          <img class="img-chat" width="60" height="60" src="assets/img/img-sidebar-chatbot-default.svg" alt="" />
        }
        <input
          type="text"
          matInput
          [(ngModel)]="text"
          (focus)="onFocusInput()"
          (keydown.enter)="onSendMessage()"
          (touchmove)="$event.stopPropagation()"
          [class.input-collapsed]="!isExpanded && showStatus !== CHATBOT_SHOW_STATUS.HIDE"
        />
        <button mat-button class="btn-icon btn-chat-send" (click)="onSendMessage()">
          <img width="60" height="60" src="assets/img/img-chatbot-send.png" alt="" />
        </button>
      </div>
    }
  </div>
</div>